export const localStorageKeys = {
  recommendationsModalSettings: 'recommendations-modal-settings',
  mageCacheStorage: 'mage-cache-storage',
} as const;

export const subKeys = {
  [localStorageKeys.recommendationsModalSettings]: {
    recommendationsPerSku: 'recommendations-per-sku',
    timeBetweenIterations: 'time-between-iterations',
    allowInStock: 'allow-in-stock',
    allowedGroups: 'allowed-groups',
    variant: 'variant',
    variantMap: 'variant-map',
  },
  [localStorageKeys.mageCacheStorage]: {
    customer: 'customer',
  },
} as const;

export const DEFAULT_ALLOWED_GROUPS = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
];

export const getRecommendationsModalSettings: () => Record<
  string,
  any
> | null = () => {
  const settingsStr = localStorage.getItem(
    localStorageKeys.recommendationsModalSettings,
  );
  const parsedSettings = settingsStr != null ? JSON.parse(settingsStr) : null;

  return parsedSettings;
};

export const getTimeBetweenIterations: () => number | null = () => {
  const settings = getRecommendationsModalSettings();
  const timeInSeconds =
    settings != null
      ? settings[
          subKeys[localStorageKeys.recommendationsModalSettings]
            .timeBetweenIterations
        ]
      : null;

  return timeInSeconds != null ? timeInSeconds * 1000 : null;
};

export const getIsInStockAllowed: () => boolean = () => {
  const settings = getRecommendationsModalSettings();
  const isInStockAllowed =
    settings != null
      ? settings[
          subKeys[localStorageKeys.recommendationsModalSettings].allowInStock
        ]
      : null;

  return isInStockAllowed ?? false;
};

export const getRecommendationVariant = (
  type: 'oos' | 'geo' | 'cart' | undefined = undefined,
) => {
  const settings = getRecommendationsModalSettings();
  const variant =
    settings?.[subKeys[localStorageKeys.recommendationsModalSettings].variant];
  const variantMap =
    settings?.[
      subKeys[localStorageKeys.recommendationsModalSettings].variantMap
    ];
  const variantByType = variantMap?.find(
    // @ts-expect-error // TODO: fix types
    (item) => item.code === `${type}_sim`,
  )?.value;

  return parseInt(variantByType) || variant || 2;
};

export const getRecommendationsPerSku: () => number | null = () => {
  const settings = getRecommendationsModalSettings();
  const recommendationsPerSku =
    settings != null
      ? settings[
          subKeys[localStorageKeys.recommendationsModalSettings]
            .recommendationsPerSku
        ]
      : null;

  return recommendationsPerSku;
};

export const getAllowedGroupIds: () => number[] = () => {
  const recommendationsModalSettings = getRecommendationsModalSettings();
  const allowedGroups =
    recommendationsModalSettings?.[
      subKeys[localStorageKeys.recommendationsModalSettings].allowedGroups
    ] ?? [];
  const parsedAllowedGroups =
    allowedGroups.length != null && allowedGroups.length > 0
      ? allowedGroups.map((strNum: string) => Number(strNum))
      : DEFAULT_ALLOWED_GROUPS;

  return parsedAllowedGroups;
};

export const getMageCacheStorage: () => Record<string, any> | null = () => {
  const mageCacheStorage = localStorage.getItem(
    localStorageKeys.mageCacheStorage,
  );
  const parsedStorage =
    mageCacheStorage != null ? JSON.parse(mageCacheStorage) : null;

  return parsedStorage;
};

export const getCustomerDataFromMageCacheStorage: () => Record<
  string,
  any
> | null = () => {
  const mageCacheStorage = getMageCacheStorage();
  const customer = mageCacheStorage?.customer || null;

  return customer;
};

export const getCartItemsIdsFromMageCacheStorage: () => Record<
  string,
  any
> | null = () => {
  try {
    const mageCacheStorage = getMageCacheStorage();
    const items = mageCacheStorage?.cart?.items || [];
    // @ts-expect-error // TODO: fix types
    return items?.map((item) => item.product_id);
  } catch (e) {
    console.log(e);
    return [];
  }

  return [];
};

export const getGroupIdFromLocalStorage: () => number | null = () => {
  const customerData = getCustomerDataFromMageCacheStorage();
  const groupId = customerData?.groupId || null;

  return groupId;
};

export const getIsTierAllowed: () => boolean = () => {
  const allowedGroups = getAllowedGroupIds();
  const groupId = getGroupIdFromLocalStorage();

  if (allowedGroups == null || groupId == null) {
    return true;
  }

  return allowedGroups.includes(Number(groupId));
};
